var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function buildSelectionPath(cardId, keyAssignmentAnswers, carouselSelectionState, selectSelectionState) {
    var carouselResult = buildCarouselSelectionPath(cardId, keyAssignmentAnswers, carouselSelectionState, selectSelectionState);
    /**
     * 選択肢ありカードの可能性があるAnswerId
     * ・ルートカードが選択肢ありカードの場合
     * ・カルーセルの選択肢に選択肢ありカードがぶら下がっている場合
     */
    var maybeAnswerSelectAnswerIds = __spreadArray([cardId], carouselResult, true);
    var selectResult = buildSelectSelectionPath(maybeAnswerSelectAnswerIds, keyAssignmentAnswers, selectSelectionState);
    return __spreadArray(__spreadArray([cardId], carouselResult, true), selectResult, true);
}
// プライベート関数だが、テストするためexportしている
export function buildSelectSelectionPath(answerIds, keyAssignmentAnswers, selectSelectionState, parentFoundAllAnswerIds) {
    if (parentFoundAllAnswerIds === void 0) { parentFoundAllAnswerIds = []; }
    var result = [];
    for (var _i = 0, answerIds_1 = answerIds; _i < answerIds_1.length; _i++) {
        var answerId = answerIds_1[_i];
        var answer = keyAssignmentAnswers[answerId];
        if (!answer || result.includes(answerId)) {
            continue;
        }
        var selectSelectionData = selectSelectionState[answerId];
        if (answer && selectSelectionData) {
            var maybeAnswerSelectAnswerId = selectSelectionData.currentActionActionId;
            var allActionIds = selectSelectionData.actionIds;
            if (maybeAnswerSelectAnswerId &&
                allActionIds.includes(maybeAnswerSelectAnswerId) &&
                !parentFoundAllAnswerIds.includes(maybeAnswerSelectAnswerId)) {
                result.push(maybeAnswerSelectAnswerId);
                var mergedParentFoundAllAnswerIds = __spreadArray(__spreadArray([], result, true), parentFoundAllAnswerIds, true);
                var childResult = buildSelectSelectionPath([maybeAnswerSelectAnswerId], keyAssignmentAnswers, selectSelectionState, mergedParentFoundAllAnswerIds);
                result.push.apply(result, childResult);
            }
        }
    }
    return result;
}
// プライベート関数だが、テストするためexportしている
export function buildCarouselSelectionPath(cardId, keyAssignmentAnswers, carouselSelectionState, selectSelectionState) {
    var result = [];
    var rootCarouselIds = findRootCarouselIds(cardId, keyAssignmentAnswers, selectSelectionState);
    if (!rootCarouselIds.length)
        return result;
    rootCarouselIds.forEach(function (rootCarouselId) {
        result.push.apply(result, buildSelectionPathByCarouselId(rootCarouselId, carouselSelectionState));
    });
    return result;
}
// テストするためexportしている
export function findRootCarouselIds(cardId, keyAssignmentAnswers, selectSelectionState) {
    var rootCarouselIds = [];
    /**
     * ルートカルーセルがあるパターン
     *
     * 1. ルートカードがカルーセル
     * 2. ルートカードが選択肢ありカードで、選択肢にカルーセルがぶら下がっている
     */
    var selectAnswerIds = Object.keys(selectSelectionState).reduce(function (acc, key) {
        var selectSelectionData = selectSelectionState[key];
        if (selectSelectionData.currentActionActionId) {
            acc.push(selectSelectionData.currentActionActionId);
        }
        return acc;
    }, []);
    var allAnswerIds = __spreadArray([cardId], selectAnswerIds, true);
    for (var _i = 0, allAnswerIds_1 = allAnswerIds; _i < allAnswerIds_1.length; _i++) {
        var answerId = allAnswerIds_1[_i];
        var answer = keyAssignmentAnswers[answerId];
        if (!answer) {
            continue;
        }
        for (var _a = 0, _b = answer.contents; _a < _b.length; _a++) {
            var content = _b[_a];
            if (content.carousel) {
                rootCarouselIds.push(content.carousel.id);
            }
        }
    }
    return rootCarouselIds;
}
// プライベート関数だが、テストするためexportしている
export function buildSelectionPathByCarouselId(carouselId, carouselSelectionState) {
    var result = [];
    var carouselPath = carouselSelectionState[carouselId];
    if (!carouselPath)
        return result;
    var currentPageId = carouselPath.currentPageID;
    var answerIds = carouselPath.selectionPath[currentPageId];
    answerIds.forEach(function (answerId) {
        if (Object.keys(carouselSelectionState).includes(answerId)) {
            var childCarousel = carouselSelectionState[answerId];
            var childCarouselSelectionPathIds = childCarousel.selectionPath[childCarousel.currentPageID];
            // カルーセルのId自体もAnswerIdなのでselectionPathに入れる必要がある
            result.push.apply(result, __spreadArray(__spreadArray([], childCarouselSelectionPathIds, false), [answerId], false));
            childCarouselSelectionPathIds.forEach(function (childCarouselId) {
                result.push.apply(result, buildSelectionPathByCarouselId(childCarouselId, carouselSelectionState));
            });
        }
        else {
            result.push(answerId);
        }
    });
    return result;
}
//# sourceMappingURL=buildPath.js.map